export default {"src":"/_next/static/media/Evidence-BasedPractices.7794e945.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};